<div *ngIf="isLoaded" class="position-relative player-content player-content--bg">
  <div class="player-content--container">
    <div class="new-question-completed pr-0 pl-0">
        <div class="new-question__container text-center">

        <div class="">
          <img src="assets/images/frame.png" alt="" width="54" class="mx-auto mb-4">
          <h3 class="mb-3 font-16 font-mob-14 montserrat-semibold">Congratulations, {{user.firstName}}!</h3>
          <p *ngIf="(totalPercentage && !inCompleteContents?.length)" class="mb-5 navColor font-22 font-mob-13">
            <strong>Great job on completing this course</strong>.</p>
          <p *ngIf="(!totalPercentage || inCompleteContents?.length)" class="mb-5 navColor font-16 font-mob-13">You have
            reached the end of <strong>{{config.courseTitle | titlecase}}</strong>.</p>
          <ng-container *ngIf="!(inCompleteExercises?.length || pendingScores)">
            <h4 class="font-16 mb-4 font-mob-13">Your <ng-container *ngIf="evaluationResult?.isNewEvaluation"
                class="">Course Score
            </ng-container> {{evaluationResult?.isNewEvaluation?'is':'Score'}}</h4>
            <div class="mb-5 new-question-completed__count"
              [class.new-question-completed__count--small]="evaluationResult?.isNewEvaluation">
              <div *ngIf="evaluationResult?.isNewEvaluation" class="new-question-completed__count--marks">
                <strong>{{totalPoints |number:'1.0-0'}}%
                </strong></div>
              <div *ngIf="!evaluationResult?.isNewEvaluation" class="new-question-completed__count--marks">
                <strong>{{totalPercentage |number:'1.0-0'}}</strong>%
              </div>
            </div>
            <ng-container *ngIf="evaluationResult?.isNewEvaluation">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-6 col-xl-5 mg-b20">
                  <table class="skill-table mg-b15 mx-auto" cellspacing="0">
                    <tr>
                      <td></td>
                      <td>Skill</td>
                      <td>Effort</td>
                      <td>Confidence</td>
                    </tr>
                    <tr *ngFor="let row of rows">
                      <td>{{row.level | titlecase}}</td>
                      <td *ngFor="let cell of cells" class="skill-table__cell">
                        <span class="skill-table__mark has-tooltip has-tooltip--mobilevisible">
                          <img *ngIf="row.level == gridResult[cell.parameter]" [src]="emojiReactions[(row.level)]" alt="">
                          <span class="custom-tooltip custom-tooltip--white custom-tooltip__top white-space-wrap no-border">
                            Throughout the course, we were helping you build your Skill, Effort and Confidence on
                            {{config.courseTitle | titlecase}}.
                          </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xl-7 text-left pl-md-4">
                  <p class="font-14 lh-26 navColor mg-b40 mg-tb-b40 pd-t30">{{evaluationResult?.message}}</p>
                  <div class="font-14 lh-26 navColor d-flex align-items-center mg-b40">
                    Course Engagement
                    <img class="ms-2" src="{{evaluationResult?.enaggmenetScoreThumbsUp?'assets/images/thumb-up.svg':'assets/images/thumb-down.svg'}}" alt="">
                  </div>
                  <div *ngIf="config?.isGenerateCompletionCertificate" class="pd-t15 pd-b15 pd-r15 pd-l15 certificate-block d-block d-xl-flex align-items-center text-left light-bg div-shadow justify-content-between">
                      <div class="d-block d-xl-flex text-center text-xl-left align-items-center justify-content-center mb-4 mb-xl-0">
                          <div class="pd-r20">
                              <i class="font-40 icon-certified primaryColor"></i>
                          </div>
                          <div class="pd-r20">
                              <!-- <h3 class="mg-b5 montserrat-bold font-14">Collect your certificate</h3> -->
                              <p class="montserrat-bold font-14">Stand out amongst your peers and professional network!</p>
                          </div>
                      </div>
                      <div class="pl-2 pl-md-2 text-center">
                          <button class="btn btn-primary btn-disabled font-14 btn-sm"
                                  (click)="openCertificate()" 
                                  [ngClass]="{'btn-disabled': progress !=100,'has-tooltip':progress !=100,'certificate-btn':progress !=100}"
                                  [disabled]="progress !=100" 
                                  type="button">
                                  <span class="d-flex align-items-center">Collect Certificate <span *ngIf="progress !=100" class="checkBox lock"></span></span>
                                  <span *ngIf="progress !=100" class="custom-tooltip custom-tooltip__top">To unlock, please complete all course content</span>
                          </button>
                      </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div *ngIf="pendingScores" class="max-width_800 pt-4 pb-4 mx-auto alert alert-warning font-16 mg-t80 mg-b80">
          Your score will be generated as soon as our Harappa Learning<br class="d-none d-md-block"> Specialists have
          graded
          your assessments.
        </div>

        <div *ngIf="inCompleteExercises?.length" class="viewScores viewScores--dark mb-5 mt-5">
          <h6 *ngIf="!pendingScores">To view your {{ config?.isGenerateCompletionCertificate?'certificate':'score'}}, please complete the course.</h6>
          <h6 *ngIf="pendingScores">We are awaiting your scores for:</h6>
          <ol class="listCourseModule text-left">
            <li class="cursor-pointer" (click)="navigateToExercise(ex.id)" *ngFor="let ex of inCompleteExercises">
              {{ex.title}}</li>
          </ol>
        </div>

        <div *ngIf="config?.isGenerateCompletionCertificate && !evaluationResult?.isNewEvaluation"
          class="py-4 mg-t80 mg-b80 certificate-block d-block d-xl-flex align-items-center text-left light-bg div-shadow justify-content-between">
          <div class="d-block d-xl-flex text-center text-xl-left align-items-center justify-content-center mb-4 mb-xl-0">
            <div class="pr-5 mb-4 mb-xl-0 pl-5">
              <i class="icon-certified certificate-block__icon primaryColor"></i>
            </div>
            <div class="pr-5 pr-md-2 pl-2">
              <h3 class="mb-2 heading20">Collect your certificate</h3>
              <p class="new-question-completed__desc">Stand out amongst your peers and professional network!</p>
            </div>
          </div>
          <div class="pr-2 pl-2 pr-md-5 pl-md-5 text-center">
            <button class="btn btn-primary"
              (click)="openCertificate()" 
              [ngClass]="{'btn-disabled': progress !=100,'has-tooltip':progress !=100,'certificate-btn':progress !=100}"
              [disabled]="progress !=100" 
              type="button"
              >
              <span class="d-flex align-items-center">View Certificate <span *ngIf="progress !=100"
                  class="checkBox lock"></span></span>
              <span *ngIf="progress !=100" class="custom-tooltip custom-tooltip__top">To unlock, please complete all
                course content</span>
            </button>
          </div>
        </div>

        <ng-container *ngIf="recommendedCourses.length">
          <h3 class="pt-5 mb-4 new-question-completed__subtitle">What next?</h3>
          <p class="mb-5 new-question-completed__desc">Continue to expand your skill set through our other high impact
            courses.</p>

          <div class="info--item-container mg-b30">
            <div *ngFor="let course of recommendedCourses| slice:0:3" (click)="goToCourse(course.title)"
              class="info--item cursor-pointer">
              <img alt="" src="{{course?.logo}}" class="mx-auto mb-5" width="110">
              <p class="heading20"><strong>{{course?.title}}</strong></p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isLoaded" class="pageloader pageLoaderQuiz-left">
  <div class="d-flex align-items-center justify-content-center pageloader--message">
    <div>
      <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif">
    </div>
  </div>
</div>

